/* =============================================
   THE SYNC – Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function() {

  // ── FAQ Accordion ──
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Purchase Option Selection ──
  document.querySelectorAll('.purchase-option').forEach(opt => {
    opt.addEventListener('click', function() {
      document.querySelectorAll('.purchase-option').forEach(o => o.classList.remove('selected'));
      this.classList.add('selected');
      const variantId = this.dataset.variantId;
      const form = document.querySelector('.product-form');
      if (form && variantId) {
        const input = form.querySelector('[name="id"]');
        if (input) input.value = variantId;
      }
    });
  });

  // ── Sticky Buy Bar ──
  const stickyBar = document.querySelector('.sticky-buy-bar');
  const hero = document.querySelector('.hero');
  if (stickyBar && hero) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(hero);
  }

  // ── Cart Count Update ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = count;
          el.style.display = count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ── Add to Cart ──
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = this.closest('form');
      if (!form) return;
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      this.textContent = 'Wird hinzugefügt…';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        this.textContent = '✓ Im Warenkorb';
        updateCartCount();
        setTimeout(() => {
          this.textContent = 'In den Warenkorb';
          this.disabled = false;
        }, 2000);
      })
      .catch(() => {
        this.textContent = 'Fehler – erneut versuchen';
        this.disabled = false;
      });
    });
  });

  // ── Scroll Fade-in ──
  const fadeEls = document.querySelectorAll('.fade-in');
  if (fadeEls.length) {
    const fadeObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(el => fadeObserver.observe(el));
  }

});
